import { CommonModule } from '@angular/common'
import { Component, inject, input } from '@angular/core'
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { Router, RouterModule } from '@angular/router'
import { Observable } from 'rxjs'
import { AssetService } from 'src/app/core/services/asset.service'
import { IAssetCategoriesResponse } from 'src/app/core/interfaces/asset.interface'
import { RoutePaths } from 'src/app/core/data/route-paths.data'
import { GlobalDataService } from 'src/app/core/services/global-data.service'
import { SearchRoutePaths } from 'src/app/core/data/search-route-paths.data'
import { StorageService } from 'src/app/core/services/storage.service'
import { ImageSourceDirective } from 'src/app/core/directives/image-source.directive'
import { LegacyImageProcessorTypes } from 'src/app/core/interfaces/image.interface'
import { ColorSchemeDirective } from 'src/app/core/directives/color-scheme.directive'
import { ButtonModule } from '../button/button.module'

@Component({
  selector: 'app-browse-by-category',
  templateUrl: './browse-by-category.component.html',
  styleUrls: ['./browse-by-category.component.scss'],
  imports: [
    CommonModule,
    RouterModule,
    MatProgressSpinnerModule,
    ImageSourceDirective,
    ColorSchemeDirective,
    ButtonModule,
  ],
})
export class BrowseByCategoryComponent {
  readonly quantityAvailable = $localize`:@@browse-by-category.quantity-available:__QUANTITY__ available`

  private _assetService = inject(AssetService)
  private _storageService = inject(StorageService)
  private _router = inject(Router)
  globalData = inject(GlobalDataService)

  enabled = input(false)
  styles = input<any>({})
  display = input(false)
  quantity = input(5, {
    transform: (value: any) => parseInt(value, 10),
  })

  categories$!: Observable<IAssetCategoriesResponse>

  RoutePaths = RoutePaths
  SearchRoutePaths = SearchRoutePaths
  LegacyImageProcessorTypes = LegacyImageProcessorTypes

  constructor() {
    toObservable(this.quantity).pipe(
      takeUntilDestroyed(),
    ).subscribe(() => {
      this.loadCategories()
    })
  }

  loadCategories(): void {
    this.categories$ = this._assetService.getCategories({
      field: 'quantity',
      direction: 'desc',
      index: 0,
      size: this.quantity(),
    }, [
      'category',
      'image',
      'list_price',
      'quantity',
    ])
  }

  loadAndOpenCategoryFilters(): void {
    this._storageService.setItem('openCategoryOnLoad', 'true', 'session')
    this._router.navigate([RoutePaths.Search])
  }
}
